import 'firebase/functions';
import Project from './init/project';

import { default as ProjectConfig } from './projectConfig';
import * as Auth from './auth';
export const firebaseFunctions = Project.Instance.functions();
export { ProjectConfig, Auth };
